const HUG_TOLERANCE = 2;

export const contentAspectRatio = (element) => {
  const name = element?.element_type_name;
  if (name === "Image") {
    const d = element?.file_details?.dimensions;
    return d?.width > 0 && d?.height > 0 ? d.width / d.height : null;
  }
  if (name === "Video" || name === "Web URL") {
    const d = element?.embed_dimensions || element?.value?.embed_dimensions;
    return d?.width > 0 && d?.height > 0 ? d.width / d.height : null;
  }
  return null;
};

export const hugRectToAspect = (rect, ratio, direction = "") => {
  if (!ratio || !(rect?.width > 0) || !(rect?.height > 0)) return rect;

  let width = rect.width;
  let height = rect.height;
  if (width / height > ratio) {
    width = height * ratio;
  } else {
    height = width / ratio;
  }

  const dw = rect.width - width;
  const dh = rect.height - height;
  if (dw <= HUG_TOLERANCE && dh <= HUG_TOLERANCE) return rect;

  const dir = String(direction).toLowerCase();

  let left = rect.left;
  if (dir.includes("left")) left = rect.left + dw;
  else if (!dir.includes("right")) left = rect.left + dw / 2;

  let top = rect.top;
  if (dir.includes("top")) top = rect.top + dh;
  else if (!dir.includes("bottom")) top = rect.top + dh / 2;

  return {
    width: Math.round(width),
    height: Math.round(height),
    top: Math.round(top),
    left: Math.round(left),
  };
};
